//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';



//  -- List books ----------------
export const invokeMainBook = (open, pages) => ({ type: ActionTypes.alert.invokeMainBook, payload: { open, pages } });
export const revokeMainbook = () => ({ type: ActionTypes.alert.removeMainBook, payload: { open: false, pages: [] } });

export const invokeEbookGalleryView = (open, pages) => ({ type: ActionTypes.alert.invokeEbookGalleryViewer, payload: { open, pages } });
export const revokeEbookGalleryView = () => ({ type: ActionTypes.alert.removeEbookGalleryView, payload: { open: false, pages: [] } });

//  -- List All books ----------------

//  -- For Sentence Starter ----------

export const invokeSentence = (open, pages) => ({ type: ActionTypes.alert.invokeSentence, payload: { open, pages } });
export const revokeSentence = () => ({ type: ActionTypes.alert.removeSentence, payload: { open: false, pages: [] } });

//  -- For Ai Answer ----------

export const invokeAiAnswer = (open, questions) => ({ type: ActionTypes.alert.invokeAiAnswer, payload: { open, questions } });
export const revokeAiAnswer = () => ({ type: ActionTypes.alert.removeAiAnswer, payload: { open: false, questions: [] } });

// -- Answer ----------------
export const invokeAnswer = (open, pages , type) => ({ type: ActionTypes.alert.invokeAnswer, payload: { open, pages ,type } });
export const revokeAnswer = () => ({ type: ActionTypes.alert.removeAnswer, payload: { open: false, pages: [] } });

// -- Story ----------------
export const invokeStory = (open, pages , type) => ({ type: ActionTypes.alert.invokeStory, payload: { open, pages ,type } });
export const revokeStory = () => ({ type: ActionTypes.alert.removeStory, payload: { open: false, pages: [] } });

//Match Making-----------------
export const invokeMatchMaking = (open) => ({ type: ActionTypes.alert.invokeMatchMaking, payload: { open: true } });
export const revokeMatchMaking = (open) => ({ type: ActionTypes.alert.revokeMatchMaking, payload: { open: false } });

// -- PDF ----------------
export const invokePDF = (open, pdf) => ({ type: ActionTypes.alert.invokePDF, payload: { open, pdf } });
export const revokePDF = () => ({ type: ActionTypes.alert.removePDF, payload: { open: false, pdf: null } });

// -- Activity Standards ----------------
export const invokeActivityStandards = (open, activities, standards, enabledStateCodes, bookData, units, pages, currentPage) => ({ 
    type: ActionTypes.alert.invokeActivityStandards, 
    payload: { open, activities, standards, enabledStateCodes, bookData, units, pages, currentPage } 
});
export const revokeActivityStandards = () => ({ 
    type: ActionTypes.alert.removeActivityStandards, 
    payload: { open: false, activities: [], standards: [], enabledStateCodes: [], bookData: null, units: [], pages: [], currentPage: null } 
});